import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { cloneDeep } from 'lodash';
import { StudentSurveyElement } from 'utils/types';
import PropTypes from 'prop-types';

const ElementDragDropContext = (props) => {
    const reorder = (list, sourceIndex, destinationIndex) => {
        const reorderedList = cloneDeep(list);
        //remove item in array at sourceIndex
        const [removedItem] = reorderedList.splice(sourceIndex, 1);
        //add removedItem back to array at destinationIndex
        reorderedList.splice(destinationIndex, 0, removedItem);
        return reorderedList;
    };

    const onDragStart = (dragResult, provided) => {
        //custom screen reader text when user picks up an element
        provided.announce(`You have picked up the element in position ${dragResult.source.index + 1} of ${props.elements.length}.`);
    };

    const onDragUpdate = (dragResult, provided) => {
        //custom screen reader text when user moves a picked up element
        const message = dragResult.destination
            ? `You have moved the element to position ${dragResult.destination.index + 1} of ${props.elements.length}.` : '';
        provided.announce(message);
    };

    const onDragEnd = (dragResult, provided) => {
        //custom screen reader text when user drops an element
        const message = dragResult.destination
            ? `You have moved the element from position ${dragResult.source.index + 1} to ${dragResult.destination.index + 1}.`
            : `The element has been returned to its starting position of ${dragResult.source.index + 1}.`;
        provided.announce(message);

        //dropped outside the list
        if (!dragResult.destination) return;

        props.setElements(reorder(props.elements, dragResult.source.index, dragResult.destination.index));
    };

    return (
        <DragDropContext onDragStart={onDragStart} onDragUpdate={onDragUpdate} onDragEnd={onDragEnd}>
            {props.children}
        </DragDropContext>
    );
}

ElementDragDropContext.propTypes = {
    elements: PropTypes.arrayOf(StudentSurveyElement).isRequired,
    setElements: PropTypes.func.isRequired
};

export default ElementDragDropContext;
